<template>
    <div class="layout align-center justify-center wrap container text-xs-center">
        <v-flex class="xs12 sm12 md12">
            <div>
                <v-card class="card card-pricing card-plain">
                    <div class="m-portlet__head" style="border-bottom: 1px solid #ebedf2;">
                        <div class="m-portlet__head-caption">
                            <div class="m-portlet__head-title" style="width: 100%">
                                <h3 class="m-portlet__head-text" style="float: initial;text-align: start;padding: 30px;">
                                    About us
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__body" style="padding: 30px;text-align: start">
                        <div class="row">

                            Example about

                        </div>
                    </div>
                </v-card>
            </div>
        </v-flex>
    </div>
</template>

<script>
    import {  VIcon, VFlex, VCard, VBtn } from 'vuetify/lib';
    export default {
        name: "About",
        components: {
            VIcon,
            VFlex,
            VCard,
            VBtn
        },
    }
</script>

<style scoped>

</style>